<template>
    <div>
        <slot :toggle="toggle" name="trigger"></slot>

        <transition
            enter-active-class="ease-out duration-200"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-200 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
           <div class="fixed z-10 inset-0 overflow-y-auto" v-show="show" style="display: none;">
                <div @click="outsideClick" class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                    <div class="relative inline-block bg-white align-bottom sm:align-middle rounded-md text-left shadow-big transform transition-all sm:my-8" :class="sizeClasses" @click.stop="" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <slot :toggle="toggle"></slot>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "Modal",
    props: {
        open: {
            default: false,
        },
        clickOutsideEnabled: {
            default: true,
        },
        size: {
            default: 'lg',
        },
    },
    emits: ['toggle'],
    data() {
        return {
            show: false,
        };
    },
    computed: {
        sizeClasses() {
            if (this.size === 'lg') {
                return 'sm:max-w-4xl sm:w-11/12';
            }

            if (this.size === 'md') {
                return 'sm:max-w-lg sm:w-10/12';
            }
        }
    },
    mounted() {
        if (this.open) {
            this.show = true;
        }
    },
    methods: {
        toggle() {
            this.show = ! this.show;
            this.$emit('toggle', this.show);
        },

        outsideClick() {
            if (this.clickOutsideEnabled) {
                this.show = false;
            }
        },
    },
}
</script>

<style scoped>

</style>
